import axios from 'axios';

export type AxiosOptions = {
  baseUrl?: string;
  url: string;
  params?: object;
  data?: object;
  method?: 'get' | 'post' | 'put' | 'patch' | 'delete';
};

export const request = async (options: AxiosOptions) => axios.request(options);
